import { isMobile, moveSite } from './js-helpers.js';

const onClick = (id, direction) => {
	document.getElementById(id)?.addEventListener('click', async function () {
		this.classList.add('active');
		await moveSite(direction);

		this.classList.remove('active');
	});
};

onClick('site-aside-header-nav-cart', 'right');
onClick('site-aside-header-nav-close', 'right');
onClick('site-main-header-cart', 'right');
onClick('site-main-header-menu', 'left');
onClick('site-cart-header-close', 'left');

document.getElementById('site-spine')?.addEventListener('click', () => {
	if (window.innerWidth > 840 && document.getElementById('site-wrapper-outer').dataset.section === 'cart') {
		moveSite('left');
	}
});

document.addEventListener('click', event => {
	const link = event.target.closest('.card-item-link');
	if (!link) return;

	if (link.href === window.location.href) {
		event.preventDefault();

		moveSite('left');
	}
});

if (!isMobile) {
	document.addEventListener('keyup', event => {
		if (event.key === ('ArrowLeft')) moveSite('left');
		if (event.key === ('ArrowRight')) moveSite('right');
	});
}
